import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Building2 } from 'lucide-react';

export function W4EmployerSection({ formData, onChange, errors, disabled }) {
    const handleChange = (field, value) => {
        onChange({
            ...formData,
            employer: {
                ...(formData.employer || {}),
                [field]: value
            }
        });
    };

    const employerData = formData.employer || {};

    return (
        <Card className="border-amber-200 bg-amber-50/50">
            <CardHeader>
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center">
                        <Building2 className="h-4 w-4 text-amber-600" />
                    </div>
                    <div>
                        <CardTitle className="text-base text-amber-900">Step 5: Employer Only Section</CardTitle>
                        <CardDescription className="text-amber-700">
                            Employers must complete this section.
                        </CardDescription>
                    </div>
                </div>
            </CardHeader>
            <CardContent className="space-y-6">
                <div className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-2">
                            <Label className="text-amber-900">Employer's Name</Label>
                            <Input
                                value={employerData.companyName || ''}
                                onChange={(e) => handleChange('companyName', e.target.value)}
                                placeholder="Business Name"
                                className="bg-white"
                                disabled={disabled}
                            />
                        </div>
                        <div className="space-y-2">
                            <Label className="text-amber-900">Employer Identification Number (EIN)</Label>
                            <Input
                                value={employerData.ein || ''}
                                onChange={(e) => handleChange('ein', e.target.value)}
                                placeholder="XX-XXXXXXX"
                                className="bg-white"
                                disabled={disabled}
                            />
                        </div>
                    </div>

                    <div className="space-y-2">
                        <Label className="text-amber-900">Employer's Address</Label>
                        <Input
                            value={employerData.address || ''}
                            onChange={(e) => handleChange('address', e.target.value)}
                            placeholder="Street Address"
                            className="bg-white mb-2"
                            disabled={disabled}
                        />
                        <div className="grid grid-cols-3 gap-2">
                            <Input
                                value={employerData.city || ''}
                                onChange={(e) => handleChange('city', e.target.value)}
                                placeholder="City"
                                className="bg-white"
                                disabled={disabled}
                            />
                            <Input
                                value={employerData.state || ''}
                                onChange={(e) => handleChange('state', e.target.value)}
                                placeholder="State"
                                className="bg-white"
                                maxLength={2}
                                disabled={disabled}
                            />
                            <Input
                                value={employerData.zipCode || ''}
                                onChange={(e) => handleChange('zipCode', e.target.value)}
                                placeholder="ZIP"
                                className="bg-white"
                                disabled={disabled}
                            />
                        </div>
                    </div>

                    <div className="space-y-2">
                        <Label className="text-amber-900">First Date of Employment</Label>
                        <Input
                            type="date"
                            value={employerData.firstDateOfEmployment || ''}
                            onChange={(e) => handleChange('firstDateOfEmployment', e.target.value)}
                            className="bg-white w-full md:w-1/2"
                            disabled={disabled}
                        />
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
